import { IconToggle } from "@app/shared";
import { QESAlert } from "@app/shared/qes-standards";
import { RoleRestricted, Roles } from "@app/user";
import { JSX } from "react";

export const cmsCreditIconToggleApply = (
    cmsCreditIsApplying: boolean,
    setCMSCreditIsApplying: (active: boolean) => void,
    cmsCreditTemplateValue: string
): JSX.Element => (
    <RoleRestricted allowedRoles={[Roles.CMS_APPLICATION_CREDIT_VIEWER]}>
        <IconToggle
            active={cmsCreditIsApplying}
            onToggle={setCMSCreditIsApplying}
            activeIconClass={["fa", "fa-check-circle"]}
            inActiveIconClass={["fa", "fa-circle-thin"]}
            baseClassName={["icon-toggle-tooltip", "mb-0", "ml-3"]}
            data-testid="cms-credit__apply-toggle"
        >
            Apply {cmsCreditTemplateValue}% CMS Application Credit
        </IconToggle>
    </RoleRestricted>
);

export const cmsCreditIconToggleChanges = (
    cmsCreditIsApplying: boolean,
    cmsCreditShowOnlyChanges: boolean,
    setCMSCreditShowOnlyChanges: (active: boolean) => void,
    cmsCreditTemplateValue: string,
    gapsFilterEnabled: boolean,
    hasCountyAndSpecialtyFilters: boolean,
): JSX.Element => (
    <RoleRestricted allowedRoles={[Roles.CMS_APPLICATION_CREDIT_VIEWER]}>
        <IconToggle
            active={cmsCreditIsApplying && cmsCreditShowOnlyChanges && !gapsFilterEnabled}
            onToggle={setCMSCreditShowOnlyChanges}
            activeIconClass={["fa", "fa-check-circle"]}
            inActiveIconClass={["fa", "fa-circle-thin"]}
            baseClassName={["icon-toggle-tooltip", "mb-0", "ml-3"]}
            data-testid="cms-credit__view-only-changes-toggle"
            disabled={!cmsCreditIsApplying || gapsFilterEnabled || hasCountyAndSpecialtyFilters}
        >
            Show Specialties that Pass with CMS {cmsCreditTemplateValue}% Application Credit
        </IconToggle>
    </RoleRestricted>
);

export const cmsCreditDataAlert = (cmsCreditTemplateValue: string): JSX.Element => (
    <QESAlert
        type="info"
        persist={true}
    >
        The following data reflects the addition of the temporary {cmsCreditTemplateValue}% CMS Application Credit. This temporary credit is only applied to Pending counties. Information about Prospect and Market networks, with regard to impact and gap filling, is unavailable when the temporary {cmsCreditTemplateValue}% CMS Application Credit toggle is applied.
    </QESAlert>
);

export const cmsCreditProvidersAlert = (cmsCreditTemplateValue: string): JSX.Element => (
    <QESAlert
        type="info"
        persist={true}
        classNames="mt-4">
        Prospect and Market providers are not viewable when the temporary {cmsCreditTemplateValue}% CMS Application Credit is applied.
    </QESAlert>
);